require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-design-anthology-toorak-garden-residence.json") })
        }
      }, "path---journal-design-anthology-toorak-garden-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-design-anthology-toorak-garden-residence!./.cache/json/journal-design-anthology-toorak-garden-residence.json
// module id = 477
// module chunks = 231608221292675